export default __webpack_public_path__ + "static/media/icon_filter.e0834eca.svg";